import { isSameDay } from "date-fns";

export function calculateBarPosition(
  checkIn: Date,
  checkOut: Date | null,
  days: Date[],
  nights: number,
  cellWidth: number,
) {
  const startIndex = days.findIndex((day) => isSameDay(day, checkIn));
  const endIndex = checkOut
    ? days.findIndex((day) => isSameDay(day, checkOut))
    : -1;

  if (startIndex === -1) return null;

  const left = startIndex * cellWidth + cellWidth / 2;

  const end =
    endIndex !== -1
      ? endIndex * cellWidth + cellWidth / 2
      : (startIndex + nights) * cellWidth + cellWidth / 2;

  return {
    left,
    width: end - left,
  };
}
